import { Text } from '@pairy/pds-react';

import * as Styled from '../index.styles';

interface Props {
  translateKoToEn: (item: string) => string;
}

const RequiredMark = ({ translateKoToEn }: Props) => {
  return (
    <Styled.MinWidthWrapper width={32}>
      <Text variant="sm-medium" color="skyblue_500">
        *{translateKoToEn('required')}
      </Text>
    </Styled.MinWidthWrapper>
  );
};

export default RequiredMark;
